import {
  Dialog,
  DialogTrigger,
  DialogSurface,
  DialogTitle,
  DialogContent,
  DialogBody,
  DialogActions,
  Button,
  makeStyles,
} from "@fluentui/react-components";
import { DeleteRegular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
import { ButtonWithLoading } from "../ButtonWithLoading";
import { useApiCache } from "../../hooks/useApiCache";
import { useState } from "react";

const useStyles = makeStyles({
  confirmButton: {
    width: "fit-content",
    gap: "8px",
  },
});

export const ClearCacheButtonDialog = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [open, setOpen] = useState<boolean>(false);

  const { mutateAsync: clearCache, isPending } = useApiCache();

  const submitClearCache = async () => {
    try {
      await clearCache();
      setOpen(false);
    } catch (error) {
      setOpen(false);
      console.warn("Clearing of cache failed:", error);
    }
  };

  return (
    <Dialog modalType="alert" open={open}>
      <DialogTrigger disableButtonEnhancement>
        <Button
          size="large"
          appearance="primary"
          className={classes.confirmButton}
          onClick={() => setOpen(true)}
        >
          <DeleteRegular />
          <span>{t("clearCache")}</span>
        </Button>
      </DialogTrigger>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{t("clearCache")}</DialogTitle>
          <DialogContent>{t("clearCachePrompt")}</DialogContent>
          <DialogActions>
            <DialogTrigger disableButtonEnhancement>
              <Button appearance="secondary" onClick={() => setOpen(false)}>
                {t("cancel")}
              </Button>
            </DialogTrigger>

            <ButtonWithLoading
              onClick={submitClearCache}
              isLoading={isPending}
              text={t("clearCache")}
            />
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default ClearCacheButtonDialog;
